<rb-loading-spinner *ngIf="dataLoadingSoc" class="spinner"></rb-loading-spinner>
<div class="row ms-0 me-0" *ngIf="errorMessageSoc && !dataLoadingSoc">
    <rb-callout type="warning">
        No data for "End State of Charge" chart.
    </rb-callout>
</div>
<div id="soc-end-chart"></div>
<div class="p-2">
    <div class="shaded-container" *ngIf="!dataLoadingSoc && !errorMessageSoc">
        Distribution of the final state of charge per charging event. The frequencies are determined from all charging phases of all vehicles in the fleet.
    </div>
</div>